const baseRoutes = require('./baseRoutes').baseRoutes;

module.exports.routes = baseRoutes;
